import './public-path'
import { createApp } from 'vue'
import App from './App.vue'
import './assets/css/tailwind.css'
import router from './router'
import { installSplitTextAntiClip } from './components/helpers/textFit'

// Silence console.log outputs globally
console.log = () => {};

// Patch SplitText before any section creates splits, so generated glyph
// wrappers are tagged for the anti-clip CSS.
installSplitTextAntiClip()

//GLOBAL CONFIG
let craftApiPreviewToken = ''
if (window.siteConfig?.xCraftLivePreview) {
    craftApiPreviewToken = '?tokenParam=' + window.siteConfig?.xCraftLivePreview + '&token=' + window.siteConfig?.xCraftLivePreviewToken
}
window.config = {
    loadedOnce: false,
    routerInTransition: false,
    localMode: (process.env.VUE_APP_ENVIRONMENT === 'local'),
    env: process.env.VUE_APP_ENVIRONMENT,
    apiroot: process.env.VUE_APP_API,
    apiext: (process.env.VUE_APP_ENVIRONMENT === 'local') ? '' : craftApiPreviewToken,
    json: {
        global: null
    },
    globalScrollReveal: {
        duration: 850,
        distance: '50px',
        viewOffset: {
            bottom: 100
        }
    },
    greenhouse:null
}

startApp();

function startApp() {
    const app = createApp(App)

    app.use(router)

    // Register the directive BEFORE mount
    app.directive('sr', {
        mounted(el, binding) {
            setTimeout(() => {
                // Lazy-load ScrollReveal dynamically below-the-fold
                import('scrollreveal').then((module) => {
                    const ScrollReveal = module.default;
                    const clonedConfig = JSON.parse(JSON.stringify(window.config.globalScrollReveal));
                    const sr = ScrollReveal(clonedConfig);
                    const obj = binding.value || {};
                    sr.reveal(el, obj, 50);
                });
            }, 100)
        }
    })

    app.mount('#app')
}